<template>
  <div class="md-layout text-center login_biz">

    <div class="md-layout-item md-size-50 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page-fix">
      <form @submit.prevent="send">
        <login-card :key="this.passResetKey" :class="this.multiple && this.consolidate ? 'full-size-recover' : ''">
          <div class="logoWpr" slot="title"><img src="/img/logo-sm.png" alt="Bizminer small logo"></div>
          <div

            class="
              md-layout-item md-size-100 md-medium-size-100 md-small-size-100
              mr-auto
            "
            slot="content"
          >

            <h1 slot="title" v-if="this.$route.path.includes('password')" class="title login-title text-center">Password Recover</h1>
            <h1 slot="title" v-else class="title login-title">Set up your Password</h1>

            <div v-if="this.logged_in && !this.valid">
              <h4 class="info-title ">Please <a href="/logout">Log Out</a> from your existing session.</h4>
            </div>
            <div v-else-if="this.valid && this.multiple && !this.consolidate">
              <h4 class="info-title ">Multiple accounts with the same email were found, that cannot be consolidated. Please contact your sales representative.</h4>
            </div>
            <div v-else-if="this.valid && !this.multiple">
              <label>New Password</label>
              <md-field
                :class="{ 'md-invalid': $v.password.$error }"
                style="margin-bottom: 1rem"
              >
                <!-- <md-icon>lock_outline</md-icon>
                <label>New Password</label> -->
                <md-input v-model="$v.password.$model" type="password" />
                <span class="md-error" v-if="!$v.password.required">
                  This field is required
                </span>
              </md-field>

              <label>Confirm Password</label>
              <md-field
                :class="{ 'md-invalid': $v.password_confirmation.$error }"
              >
                <!-- <md-icon>lock_outline</md-icon>
                <label>Confirm Password</label> -->
                <md-input
                  v-model="$v.password_confirmation.$model"
                  type="password"
                />
                <span class="md-error" v-if="!$v.password_confirmation.required">
                  This field is required
                </span>
                <span
                  class="md-error"
                  v-if="!$v.password_confirmation.sameAsPassword"
                  style="bottom: -20px"
                >
                  Passwords must be identical
                </span>
              </md-field>
              <div class="button-container">
                <md-button
                  class="md-info md-round mt-4"
                  type="submit"
                  slot="footer"
                  >
                  Send
                </md-button>
              </div>
            </div>
            <div v-else-if="this.multiple && this.consolidate">
              <h4 class="info-title text-center"> More than one account with this email address was found. Please select one account from the list below you'd like to keep as your primary. All of your data from the other accounts will be merged into your primary account.</h4>
              <span class="md-error" v-if="this.errorMessage"
                  >You need to select one of those accounts below</span
                >
              <div style="padding-top:20px" class="md-layout-item md-size-100">
              <md-table class="recoverTable m-b-30" v-model="this.accounts"
                table-header-color="blue">
                <md-table-row class="tableHead">
                  <md-table-head></md-table-head>
                  <md-table-head>BILLING NAME</md-table-head>
                  <md-table-head>BILLING EMAIL</md-table-head>
                  <md-table-head>AUTHORIZED NAME</md-table-head>
                  <md-table-head>AUTHORIZED EMAIL</md-table-head>
                  <md-table-head>LAST LOGIN</md-table-head>
                </md-table-row>
                <md-table-row v-for="item in accounts" :key="item.uid">
                  <md-table-cell md-label="Parameters">
                    <md-radio v-model="radioAccount" :value="item.uid"></md-radio>
                  </md-table-cell>
                  <md-table-cell md-label="Parameters">
                    {{ item.billing_name }}
                  </md-table-cell>
                  <md-table-cell md-label="Parameters">
                    {{ item.billing_email }}
                  </md-table-cell>
                  <md-table-cell md-label="Parameters">
                    {{ item.authorized_name }}
                  </md-table-cell>
                  <md-table-cell md-label="Parameters">
                    {{ item.authorized_email }}
                  </md-table-cell>
                  <md-table-cell md-label="Parameters">
                    {{ formatDate(item.last_login) }}
                  </md-table-cell>


                </md-table-row>
                <md-table-row></md-table-row>
              </md-table>



            <label>New Password</label>
            <md-field
              :class="{ 'md-invalid': $v.password.$error }"
              style="margin-bottom: 1rem"
            >
              <!-- <md-icon>lock_outline</md-icon>
              <label>New Password</label> -->
              <md-input v-model="$v.password.$model" type="password" />
              <span class="md-error" v-if="!$v.password.required">
                This field is required
              </span>
            </md-field>

            <label>Confirm Password</label>
            <md-field
              :class="{ 'md-invalid': $v.password_confirmation.$error }"
            >
              <!-- <md-icon>lock_outline</md-icon>
              <label>Confirm Password</label> -->
              <md-input
                v-model="$v.password_confirmation.$model"
                type="password"
              />
              <span class="md-error" v-if="!$v.password_confirmation.required">
                This field is required
              </span>
              <span
                class="md-error"
                v-if="!$v.password_confirmation.sameAsPassword"
                style="bottom: -20px"
              >
                Passwords must be identical
              </span>
            </md-field>

            <div class="button-container">
              <md-button
                class="md-info md-round mt-4"
                type="submit"
                slot="footer"
                >
                Send
              </md-button>
            </div>

              </div>

            </div>
            <div v-else-if="!this.valid">
              <h4 class="info-title ">This password reset link is invalid or expired.</h4>
            </div>
          </div>
        </login-card>
      </form>
    </div>
  </div>
</template>

<script>
import { LoginCard } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { required, sameAs } from "vuelidate/lib/validators";
import sha256 from "crypto-js/sha256";
import axios from "axios";

export default {
  components: {
    LoginCard,
  },
  mixins: [formMixin],
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated();
    },
  },
  data: () => ({
    errorMessage: false,
    radioAccount: null,
    consolidate_parent_uid: null,
    accounts:[],
    valid: false,
    multiple: false,
    consolidate: true,
    logged_in: false,
    password: null,
    password_confirmation: null,
    passResetKey: 0
  }),
  validations: {
    password: {
      required,
    },
    password_confirmation: {
      required,
      sameAsPassword: sameAs("password"),
    },
  },
  methods: {
    formatDate: function (dateString) {
            let date = new Date(dateString);
            return ((date.getMonth() > 8) ?
                (date.getMonth() + 1)
                : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9)
                    ? date.getDate()
                    : ('0' + date.getDate())) + '/' + date.getFullYear();
        },
    async sessionPasswordCheck() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(process.env.VUE_APP_API_BASE_URL + '/session/password_recover_check',
          {},
          {
            params: {
              session_id: currentSession,
              recovery_hash:this.$route.params.hash,
            },
          }
        ).then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            if(res.data?.errorCode === "logged_in") {
              this.logged_in = true;
              this.passResetKey++;
              return;
            } else {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                'SET_ERROR_INFO', '<br>' +
                'Server responded with error = True <br> errorCode: ' + res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + " /session/password_recover_check/" <br>`
              );
              throw new Error(
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
              );
            }
          }

          if(res.data.errorCode === "logged_in") {
              this.logged_in = true;
              this.passResetKey++;
          }

          if(res.data.accounts){
            this.accounts = res.data?.accounts;
            this.radioAccount = res.data?.accounts[0].uid;
          }

          this.consolidate = res.data?.consolidate;
          this.multiple = res.data?.multiple;
          this.valid = res.data?.valid;
          this.passResetKey++;
        });
    },
    async send() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        await this.$store.dispatch("alerts/error", "Please enter inputs!");
        return false;
      } else {
        if (this.$route.params.hash) {
          if(this.multiple && this.consolidate && !this.consolidate_parent_uid){
            this.errorMessage = true;
          }
          else{
            this.$store.dispatch("recoverPassword", {
              new_password: sha256(this.password).toString(),
              validate: true,
              recovery_hash: this.$route.params.hash,
              consolidateUID: this.consolidate_parent_uid,
            }).then(async (res) => {
              if (!res) {
                return;
              }
              if (res.error) {
                if (res.errorCode === 'recovery_used') {
                  await this.$store.dispatch("alerts/error","Password recovery code used!");
                }
              } else {
                this.$store.dispatch("recoverPassword", {
                  new_password: sha256(this.password).toString(),
                  recovery_hash: this.$route.params.hash,
                }).then(async (res) => {
                  if (!res.error) {
                    await this.$store.dispatch("alerts/success","Password successfully reset.");
                    this.$router.push({ name: 'Login' });
                  }
                });
              }
            });
          }

        } else {
          this.$store.dispatch("alerts/error", "You can't reset password");
        }
      }
    },
  },
  async mounted() {
    await this.sessionPasswordCheck();
  },
  watch: {
    radioAccount(val) {
      this.consolidate_parent_uid = val;
    },
  },
};
</script>
<style scoped>
.login-fix-page {
  padding-bottom: 7em;
  padding-top: 4em;
}
</style>
